
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

import { Job } from '@/domains/global/models'

@Component
export default class JobDisputeMessage extends Vue {
  @Prop({ type: Object as () => Job, required: true })
  job!: Job

  get disputeRoute() {
    return { name: 'disputes-read', params: { id: this.job.disputeId.toString() } }
  }
}
